import React, { useState, useEffect, useRef } from 'react'
import Loader from '../../../presentationals/Loader/Loader.component'
import moment from 'moment'
import { getWebsiteLeadsBetweenDates } from '../AdminActionCreator.component'
import DateFilterSelect from '../../../CustomDatePicker/DateFilterSelectold'
import { useSelector, useDispatch } from 'react-redux'
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer'

const PAGE_SIZE_OPTIONS = [10, 25, 50]

export default function UserConsents() {
    const dispatch = useDispatch()
    const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters)

    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState([])
    const [search, setSearch] = useState('')
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const debounceRef = useRef(null)
    const isFirstRender = useRef(true)

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            fetchData(fromDate, toDate)
            return
        }
        clearTimeout(debounceRef.current)
        debounceRef.current = setTimeout(() => {
            fetchData(fromDate, toDate)
        }, 300)
        return () => clearTimeout(debounceRef.current)
    }, [fromDate, toDate])

    const handleDateFilterPopup = (type, val) => {
        dispatch({
            type: FILTER_ACTION,
            payload: { [type === 'from' ? 'fromDate' : 'toDate']: val }
        })
    }

    const fetchData = (from, to) => {
        setLoader(true)
        setPage(1)
        getWebsiteLeadsBetweenDates(
            from,
            to,
            (data) => {
                setTableData(Array.isArray(data) ? data : [])
                setLoader(false)
            }
        )
    }

    const filtered = tableData.filter(row =>
        !search ||
        (row?.name || '').toLowerCase().includes(search.toLowerCase()) ||
        (row?.company || '').toLowerCase().includes(search.toLowerCase()) ||
        (row?.phoneNumber || '').includes(search)
    )

    const totalPages = Math.ceil(filtered.length / perPage)
    const paginated = filtered.slice((page - 1) * perPage, page * perPage)

    return (
        <>
            {loader && <Loader />}

            <div style={{ padding: '24px' }}>

                <h3 style={{ marginBottom: 4, fontWeight: 600 }}>User Consents</h3>

                {/* Toolbar */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', marginBottom: 16, marginTop: 16 }}>
                    <DateFilterSelect
                        value={[new Date(fromDate), new Date(toDate)]}
                        onChange={(range) => {
                            handleDateFilterPopup('from', range[0])
                            handleDateFilterPopup('to', range[1])
                        }}
                        isFilterCleared={false}
                    />
                    <input
                        style={{
                            maxWidth: 220,
                            fontSize: 13,
                            padding: '6px 12px',
                            border: '1px solid #dee2e6',
                            borderRadius: 6,
                            outline: 'none',
                            color: '#212529'
                        }}
                        placeholder='Search name, company, phone…'
                        value={search}
                        onChange={e => { setSearch(e.target.value); setPage(1) }}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#6c757d' }}>
                        <span>Show</span>
                        <select
                            style={{
                                padding: '5px 8px',
                                fontSize: 13,
                                border: '1px solid #dee2e6',
                                borderRadius: 6,
                                background: '#fff',
                                color: '#212529',
                                outline: 'none'
                            }}
                            value={perPage}
                            onChange={e => { setPerPage(+e.target.value); setPage(1) }}
                        >
                            {PAGE_SIZE_OPTIONS.map(n => (
                                <option key={n} value={n}>{n}</option>
                            ))}
                        </select>
                        <span>entries</span>
                    </div>
                </div>

                {/* Table Card */}
                <div style={{
                    background: '#fff',
                    borderRadius: 10,
                    border: '1px solid #e9ecef',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                    overflow: 'hidden'
                }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                            <thead>
                                <tr style={{ background: '#f8f9fa', borderBottom: '1px solid #e9ecef' }}>
                                    {['#', 'Name', 'Phone', 'Company', 'Source', 'Consent', 'Created At'].map(h => (
                                        <th key={h} style={{
                                            padding: '10px 14px',
                                            fontSize: 11,
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: '.5px',
                                            color: '#6c757d',
                                            whiteSpace: 'nowrap',
                                            textAlign: 'left'
                                        }}>
                                            {h}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.length === 0 && !loader ? (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: 'center', padding: '48px 24px', color: '#adb5bd', fontSize: 14 }}>
                                            No records found
                                        </td>
                                    </tr>
                                ) : (
                                    paginated.map((row, i) => (
                                        <tr
                                            key={row.id ?? i}
                                            style={{ borderBottom: '1px solid #f1f3f5' }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                                            onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                        >
                                            <td style={{ padding: '11px 14px', color: '#adb5bd', fontFamily: 'monospace' }}>
                                                {(page - 1) * perPage + i + 1}
                                            </td>
                                            <td style={{ padding: '11px 14px', fontWeight: 500, color: '#212529' }}>
                                                {row.name || '—'}
                                            </td>
                                            <td style={{ padding: '11px 14px', fontFamily: 'monospace', fontSize: 12, color: '#495057' }}>
                                                {row.phoneNumber || '—'}
                                            </td>
                                            <td style={{ padding: '11px 14px', color: '#495057' }}>
                                                {row.company || '—'}
                                            </td>
                                            <td style={{ padding: '11px 14px', fontSize: 12, color: '#6c757d' }}>
                                                {row.source || '—'}
                                            </td>
                                            <td style={{ padding: '11px 14px' }}>
                                                <ConsentBadge status={row.consent} />
                                            </td>
                                            <td style={{ padding: '11px 14px', fontFamily: 'monospace', fontSize: 12, color: '#6c757d', whiteSpace: 'nowrap' }}>
                                                {row.createdAt
                                                    ? moment(row.createdAt).format('DD MMM YYYY, hh:mm A')
                                                    : '—'}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '10px 16px',
                        borderTop: '1px solid #e9ecef',
                        background: '#f8f9fa',
                        flexWrap: 'wrap',
                        gap: 8
                    }}>
                        <small style={{ color: '#6c757d', fontSize: 12 }}>
                            {filtered.length > 0
                                ? `Showing ${(page - 1) * perPage + 1}–${Math.min(page * perPage, filtered.length)} of ${filtered.length} records`
                                : 'No results'}
                        </small>
                        <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
                    </div>
                </div>
            </div>
        </>
    )
}

function ConsentBadge({ status }) {
    const map = {
        yes:     { label: 'Consented', bg: '#EAF3DE', color: '#3B6D11' },
        no:      { label: 'Declined',  bg: '#FCEBEB', color: '#A32D2D' },
        pending: { label: 'Pending',   bg: '#FAEEDA', color: '#854F0B' },
    }
    const key = (status || '').toLowerCase()
    const s = map[key] || { label: status || '—', bg: '#f0f0f0', color: '#555' }
    return (
        <span style={{
            display: 'inline-block',
            background: s.bg,
            color: s.color,
            padding: '3px 10px',
            borderRadius: 20,
            fontSize: 11,
            fontWeight: 600,
        }}>
            {s.label}
        </span>
    )
}

function Pagination({ page, totalPages, onPageChange }) {
    if (totalPages <= 1) return null

    const pages = []
    const lo = Math.max(1, page - 2)
    const hi = Math.min(totalPages, page + 2)

    if (lo > 1) {
        pages.push(1)
        if (lo > 2) pages.push('...')
    }
    for (let p = lo; p <= hi; p++) pages.push(p)
    if (hi < totalPages) {
        if (hi < totalPages - 1) pages.push('...')
        pages.push(totalPages)
    }

    const btnBase = {
        minWidth: 30,
        height: 30,
        padding: '0 8px',
        border: '1px solid #dee2e6',
        borderRadius: 6,
        background: '#fff',
        cursor: 'pointer',
        fontSize: 13,
        color: '#495057',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit'
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <button
                style={{ ...btnBase, ...(page === 1 ? { opacity: 0.4, cursor: 'not-allowed' } : {}) }}
                onClick={() => page > 1 && onPageChange(page - 1)}
                disabled={page === 1}
            >
                ‹
            </button>

            {pages.map((p, i) =>
                p === '...'
                    ? <span key={`e${i}`} style={{ padding: '0 4px', fontSize: 12, color: '#adb5bd' }}>…</span>
                    : <button
                        key={p}
                        style={{
                            ...btnBase,
                            ...(p === page ? { background: '#212529', color: '#fff', borderColor: '#212529' } : {})
                        }}
                        onClick={() => onPageChange(p)}
                    >
                        {p}
                    </button>
            )}

            <button
                style={{ ...btnBase, ...(page === totalPages ? { opacity: 0.4, cursor: 'not-allowed' } : {}) }}
                onClick={() => page < totalPages && onPageChange(page + 1)}
                disabled={page === totalPages}
            >
                ›
            </button>
        </div>
    )
}